if (!customElements.get('switcher-section')) {
  class SwitcherSection extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.settings = {
        buttons: this.querySelectorAll("[data-switcher-btn]"),
        buttonBg: this.querySelector("[data-switcher-btn-bg]"),
        items: this.querySelectorAll("[data-switcher-item]")
      };

      if (this.settings.buttons.length > 1) {
        this.calcSizes();

        window.addEventListener("resize", (e) => {
          setTimeout(() => {
            this.calcSizes();
          }, 500);
        });

        screen.orientation.addEventListener("change", (e) => {
          setTimeout(() => {
            this.calcSizes();
          }, 500);
        });
      }
    }

    calcSizes() {
      this.settings.buttonLeft = {};
      let buttonBgLeft = 4;
      this.settings.buttons.forEach((button, index) => {
        this.settings.buttonLeft[index] = buttonBgLeft;
        let buttonWidth = button.getBoundingClientRect().width;
        buttonBgLeft += buttonWidth;
        if (button.classList.contains("active")) {
          this.moveButtonBg(button);
        }
        button.addEventListener("click", () => {
          this.switchItem(button);
        });
      });
    }

    moveButtonBg(button) {
      const btnWidth = button.getBoundingClientRect().width + "px";
      this.settings.buttonBg.style.width = btnWidth;
      let btnIndex = parseInt(button.dataset.btnIndex);
      this.settings.buttonBg.style.left = "" + this.settings.buttonLeft[btnIndex] + "px";
    }

    switchItem(btn) {
      this.settings.buttons.forEach((button) => {
        button.classList.remove("active");
      });
      btn.classList.add("active");
      this.moveButtonBg(btn);
      this.settings.items.forEach((item) => {
        item.classList.remove("active");
      });
      this.settings.items[parseInt(btn.dataset.btnIndex)].classList.add("active");
    }
  }

  customElements.define('switcher-section', SwitcherSection);
}
